/** Macro #30 — shared Social UI atoms (icons, pill styles, spinner). */
import { cn } from "../cn";

export const PILL =
  "inline-flex items-center gap-1.5 rounded-full border border-white/12 bg-white/[0.04] px-3 py-1.5 " +
  "font-mono text-[11px] font-semibold uppercase tracking-[0.12em] text-white/80 transition-colors " +
  "hover:border-neon-teal/60 hover:text-white disabled:opacity-40 disabled:cursor-not-allowed no-underline";

export const PILL_ACTIVE = "border-neon-teal/70 text-neon-teal";
export const PILL_CORAL = "border-neon-coral/60 text-neon-coral";

export function Spinner({ className }: { className?: string }) {
  return (
    <svg className={cn("animate-spin", className)} width="13" height="13" viewBox="0 0 16 16" fill="none" aria-hidden>
      <circle cx="8" cy="8" r="6.2" stroke="currentColor" strokeWidth="1.5" opacity="0.25" />
      <path d="M8 1.8A6.2 6.2 0 0 1 14.2 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}

export function HeartIcon({ filled }: { filled?: boolean }) {
  return (
    <svg width="13" height="13" viewBox="0 0 16 16" fill={filled ? "currentColor" : "none"} aria-hidden>
      <path d="M8 13.5S2 10 2 5.9A3.1 3.1 0 0 1 8 4.4 3.1 3.1 0 0 1 14 5.9C14 10 8 13.5 8 13.5Z"
            stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round" />
    </svg>
  );
}

export function BookmarkIcon({ filled }: { filled?: boolean }) {
  return (
    <svg width="13" height="13" viewBox="0 0 16 16" fill={filled ? "currentColor" : "none"} aria-hidden>
      <path d="M4 2.5h8v11l-4-2.6-4 2.6v-11Z" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round" />
    </svg>
  );
}

export function CommentIcon() {
  return (
    <svg width="13" height="13" viewBox="0 0 16 16" fill="none" aria-hidden>
      <path d="M2.5 3.5h11v7h-6L4 13v-2.5H2.5v-7Z" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round" />
    </svg>
  );
}

export function MoreIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="currentColor" aria-hidden>
      <circle cx="3.2" cy="8" r="1.3" /><circle cx="8" cy="8" r="1.3" /><circle cx="12.8" cy="8" r="1.3" />
    </svg>
  );
}
